import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

export const CashBalance = () => {
  const formBag = useFormContext<FormFields>();

  const defaultValue = formBag.watch('NonSpecificPositionsValue');

  return (
    <InputNumberMask
      {...formBag.register('NonSpecificPositionsValue')}
      defaultValue={defaultValue || undefined}
      leftIcon="fa fa-dollar-sign"
      label="Cash Value"
    />
  );
};
